import container, { containerVariants, type ContainerVariantsType } from './container';
import heading, { headingVariants, type HeadingVariantsType } from './heading';
import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const featureGrid = {
  container,
  heading,
};

export const featureGridVariants = {
  container: containerVariants,
  heading: headingVariants,
};

export type FeatureGridComponentsType = 'container' | 'heading';

export interface FeatureGridType {
  /** The FeatureGrid subcomponent types. */
  SubComponents: {
    [K in FeatureGridComponentsType]: Product.VariantKeyModes<
      K extends 'container' ? ContainerVariantsType : K extends 'Heading' ? HeadingVariantsType : never
    >;
  };
  /** The FeatureGrid container Component. */
  Container: CustomTheme.VariantKeys<ContainerVariantsType>;
  /** The FeatureGrid (Heading & Subheading) container styles. */
  Heading: CustomTheme.VariantKeys<HeadingVariantsType | HeadingVariantsType[]>;
}

export default featureGrid;
